/**
 * The people met about the world: monks, guards, the world boss, assassins, bandits, the
 * merchant, the guide and the snow sect's traitors.
 */
import { LOOKS, heroBase } from './heroes';
import { JINYIWEI_ROBE, SHAOLIN_ROBE } from './uniforms';

LOOKS.monk = {
  school: 'bell-stone',
  ...heroBase,
  ...SHAOLIN_ROBE,
  faceStyle: 'refSerious',
  iris: '#3a2418',
  brow: '#5a3a28',
  poseFaces: { atk: 'refShout', block: 'refGrit', cast: 'refGrit' },
  // Shaven head: the "hair" is the scalp.
  hair: '#e2b48e',
  hairH: '#f2caa6',
  hairStyle: 'topknot',
  headwear: 'none',
  weapon: 'staff',
  blade: '#8a5a2a',
  bladeS: '#5a3a1a',
  guard: '#f0c040',
  tassel: '#f0c040',
};
LOOKS.guardOfficer = {
  school: 'lantern-road',
  ...heroBase,
  ...JINYIWEI_ROBE,
  faceStyle: 'refCold',
  iris: '#2a1a14',
  brow: '#120c0a',
  poseFaces: { atk: 'refShout', block: 'refGrit', cast: 'refGrit' },
  hair: '#141418',
  hairH: '#3a3a48',
  hairStyle: 'topknot',
  headwear: 'guan',
  accent: '#1c1c24',
  crown: '#1c1c24',
  crownS: '#e8b84a',
  beard: 'stubble',
};
/** จอมมารพันกระบี่: the world boss, in gold-trimmed black armour with a crown of swords. */
LOOKS.worldBoss = {
  ...LOOKS.boss!,
  hair: '#1a1018',
  hairH: '#4a2a3a',
  iris: '#ffb020',
  outer: '#141018',
  outerS: '#08060a',
  outerH: '#2e2434',
  trim: '#e8b84a',
  inner: '#5a0a12',
  innerS: '#3a060c',
  sash: '#e8b84a',
  sashS: '#a07a2a',
  crown: '#e8b84a',
  crownS: '#7a5a1a',
  accent: '#e8b84a',
  pauldron: { c: '#1a141e', s: '#e8b84a' },
  cape: '#5a0a12',
  capeS: '#3a060c',
  blade: '#2a2632',
  bladeS: '#ffb020',
  guard: '#e8b84a',
  tall: 14,
};
/** นักฆ่าเงาดำ: all in black, masked, a short blade. */
LOOKS.assassin = {
  ...LOOKS.bandit!,
  hair: '#0e0c12',
  hairH: '#2a2632',
  hairStyle: 'topknot',
  headwear: 'band',
  accent: '#1a1820',
  outer: '#1c1a22',
  outerS: '#0e0c12',
  outerH: '#34303e',
  trim: '#4a1a22',
  inner: '#14121a',
  innerS: '#0a090e',
  sash: '#4a1a22',
  sashS: '#2a0e12',
  boots: '#0e0c12',
  bootsS: '#24202a',
  pelt: undefined,
  mask: '#14121a',
  weapon: 'sword',
  wlen: 13,
  blade: '#cfd4de',
  bladeS: '#6a7280',
  beard: undefined,
};
/** พระนอกรีต: a grey-robed renegade monk with an iron staff. */
LOOKS.rogueMonk = {
  ...LOOKS.monk!,
  school: undefined,
  outer: '#5a5a62',
  outerS: '#3e3e46',
  outerH: '#7a7a84',
  trim: '#2a2a30',
  inner: '#3a2a20',
  innerS: '#2a1c14',
  sash: '#8a2a20',
  sashS: '#5a1a14',
  blade: '#5a5a66',
  bladeS: '#2a2a32',
  guard: '#8a8a96',
  faceStyle: 'refCold',
  beard: 'stubble',
};
/** โจรมีดบิน: a lean bandit in a green vest, knives at the belt. */
LOOKS.knifer = {
  ...LOOKS.bandit!,
  outer: '#3e5a3a',
  outerS: '#2a4026',
  outerH: '#5a7a52',
  headwear: 'band',
  accent: '#c8a03a',
  pelt: undefined,
  weapon: 'none',
};
/** ผีกระโดด: a jiangshi in a Qing official's robe, pale green skin, arms outstretched. */
LOOKS.jiangshi = {
  ...LOOKS.bandit!,
  skin: '#a8c4a0',
  skinS: '#7e9c78',
  iris: '#1a1a1a',
  irisH: '#3a3a3a',
  hair: '#141418',
  hairH: '#2a2a32',
  hairStyle: 'topknot',
  headwear: 'guan',
  crown: '#141418',
  crownS: '#c8343a',
  accent: '#c8343a',
  outer: '#2a3a6a',
  outerS: '#1a2648',
  outerH: '#3e5490',
  trim: '#e8b84a',
  inner: '#1a2648',
  innerS: '#101830',
  sash: '#e8b84a',
  sashS: '#a07a2a',
  boots: '#141418',
  bootsS: '#2a2a32',
  pelt: undefined,
  shortRobe: false,
  sleeveless: false,
  weapon: 'none',
  beard: undefined,
  faceStyle: 'refCold',
};
/** เถ้าแก่ฉาง: a stout travelling merchant in a brown coat and a round cap. */
LOOKS.merchant = {
  ...LOOKS.bandit!,
  skin: '#e2b48e',
  skinS: '#b8885f',
  hair: '#3a2a20',
  hairH: '#5a4030',
  hairStyle: 'topknot',
  headwear: 'guan',
  crown: '#2a1a14',
  crownS: '#c8a03a',
  accent: '#2a1a14',
  outer: '#8a5a2a',
  outerS: '#5e3a18',
  outerH: '#b07a42',
  trim: '#e8c870',
  inner: '#d8c8a0',
  innerS: '#a89870',
  sash: '#c8a03a',
  sashS: '#8a6a20',
  pelt: undefined,
  shortRobe: false,
  sleeveless: false,
  weapon: 'none',
  beard: 'long',
  beardColor: '#3a2a20',
  faceStyle: 'refSmirk',
};
/** ผู้นำทางเขา: a mountain guide in furs and a bamboo hat, walking staff in hand. */
LOOKS.guide = {
  ...LOOKS.monk!,
  school: undefined,
  hair: '#3a2a20',
  hairH: '#5a4030',
  outer: '#6a5a44',
  outerS: '#4a3e2e',
  outerH: '#8a7860',
  trim: '#c8b08a',
  inner: '#d8ccb0',
  innerS: '#a89a80',
  sash: '#8a3a2a',
  sashS: '#5a2418',
  hat: { c: '#c4a468', s: '#8a6e3e' },
  pelt: { c: '#d8d0c4', s: '#a89e90' },
  beard: 'stubble',
  faceStyle: 'refSmirk',
};
/** ศิษย์สำนักหิมะทรยศ: white and ice-blue robes, gone over to the demon. */
LOOKS.frostman = {
  ...LOOKS.bandit!,
  hair: '#e8ecf4',
  hairH: '#ffffff',
  hairStyle: 'topknot',
  headwear: 'band',
  accent: '#5aa8e8',
  outer: '#dce6f2',
  outerS: '#a8b8cc',
  outerH: '#ffffff',
  trim: '#3a6a9a',
  inner: '#3a6a9a',
  innerS: '#28507a',
  sash: '#3a6a9a',
  sashS: '#28507a',
  pelt: undefined,
  shortRobe: false,
  sleeveless: false,
  weapon: 'sword',
  blade: '#d8f4ff',
  bladeS: '#5fb8e8',
  guard: '#7fd8ff',
  beard: undefined,
  faceStyle: 'refCold',
};
